import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { Container } from "react-bootstrap";
import { motion} from "motion/react";
import { useContext, useEffect,useLayoutEffect, useRef, useState } from "react";
import { WindowSize } from "../../../context/WindowContext";
export default function ProductsShow(props){
    const [clientWidth,setClientWidth]=useState(null);
      //contect for mobile
      const mobSize=useContext( WindowSize);
      const windowSize =mobSize.windowSize;
      //useRef for  div for scroll
      const scrollDiv= useRef(null);
      //handle scroll
      useLayoutEffect(()=>{
         setClientWidth(scrollDiv.current.scrollWidth + 200);
      },[]);
      function handleScroll(dir){
        if(dir=='left')
           scrollDiv.current.scrollLeft -= 250
        else if(dir=='right')    
          scrollDiv.current.scrollLeft += 250
    }
    return(<>
                   {windowSize>='768'  && clientWidth>window.innerWidth && <FontAwesomeIcon className="cursor arrow-scroll-x" onClick={()=>handleScroll("left")}
                   icon={faAnglesLeft} style={{left:'0'}} />}
                   <Container>
                   <h3 style={{marginBottom:'25px',textShadow: '2px 2px white'}}>{props.title}</h3>
                   <div ref={scrollDiv} className="hiddin-scrollBar d-flex align-items-center justify-content-start w-100" 
                   style={{gap:'1%', overflowX:'auto',padding:'20px'}}>
                       {props.data}
                   </div>
                   </Container>
                   {windowSize>='768' && clientWidth>window.innerWidth &&<FontAwesomeIcon className="cursor arrow-scroll-x" onClick={()=>handleScroll("right")}
                    icon={faAnglesRight} style={{right:'0'}} />}
            </>
    );
}